/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowGuide = createReactComponent("arrow-guide", "IconArrowGuide", [
  ["path", { d: "M5 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", key: "svg-0" }],
  ["path", { d: "M7 19h3a2 2 0 0 0 2 -2v-8a2 2 0 0 1 2 -2h7", key: "svg-1" }],
  ["path", { d: "M18 4l3 3l-3 3", key: "svg-2" }]
]);

export { IconArrowGuide as default };
//# sourceMappingURL=IconArrowGuide.js.map
